export default class IdGenerator {
  constructor() {
    this.currentId = 0
    this.ids = new WeakMap()
  }

  getId(object) {
    let id
    if (this.ids.has(object)) {
      id = this.ids.get(object)
    } else {
      id = this.currentId
      this.currentId++
      this.ids.set(object, id)
    }
    return id
  }
}
